import { createSlice } from "@reduxjs/toolkit";

const SellOrdersSlice = createSlice({
  name: "sellOrders",
  initialState: {
    loading: false,
    data: [],
    total: 0,
    message: "",
    error: null,
    orderDetails: null,
    detailsLoading: false,
    detailsError: null,
    successMessage: null,
    errorMessage: null,
  },
  reducers: {
    fetchSellOrdersRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchSellOrdersSuccess: (state, action) => {
      state.loading = false;
      state.data = JSON.parse(JSON.stringify(action.payload.orders));
      state.total = action.payload.total;
      state.message = action.payload.message;
    },
    fetchSellOrdersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchSellOrderDetailsRequest: (state) => {
      state.detailsLoading = true;
      state.detailsError = null;
      state.orderDetails = null;
    },
    fetchSellOrderDetailsSuccess: (state, action) => {
      state.detailsLoading = false;
      state.orderDetails = action.payload;
    },
    fetchSellOrderDetailsFailure: (state, action) => {
      state.detailsLoading = false;
      state.detailsError = action.payload;
    },
    updateSellOrderRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    updateSellOrderSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload;
      state.successMessage = action.payload?.message || "Status updated successfully";
    },
    updateSellOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearSellMessages: (state) => {
      state.successMessage  = null;
      state.errorMessage = null;
    },
  },
});

export const {
  fetchSellOrdersRequest,
  fetchSellOrdersSuccess,
  fetchSellOrdersFailure,
  fetchSellOrderDetailsRequest,
  fetchSellOrderDetailsSuccess,
  fetchSellOrderDetailsFailure,
  updateSellOrderRequest,
  updateSellOrderSuccess,
  updateSellOrderFailure,
  clearSellMessages,
} = SellOrdersSlice.actions;

export default SellOrdersSlice.reducer;
